<script>
export default {
  name: 'Remark',
  props: {
    exceptionData: {
      type: Object,
      default: () => ({
        valid: true,
      }),
    },
    exceptionId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      localException: {
        valid: true,
        ...this.exceptionData,
      },
    };
  },
  mounted() {
    this.$emit('update', { id: this.exceptionId, data: this.localException });
  },
};
</script>

<template>
  <v-layout wrap>
    <v-flex xs12>
      <span class="d-block">
        This exception skips all bookings with a payment remark
      </span>
    </v-flex>
  </v-layout>
</template>



// WEBPACK FOOTER //
// src/components/Reminders/ExceptionTypes/Remark.vue